module.exports = __webpack_public_path__ + "static/media/Background_Top.fd717dac.png";